<template>
    <div class="form-container">
        <form-element :hotspot="hotspot"
                      :translate-labels="translateLabels"
                      v-for="hotspot in hotspotWithLargeForms"
                      :key="'h-' + hotspot['hotspotId']"
        />
        <form-element-small :hotspot="hotspot"
                      :translate-labels="translateLabels"
                      v-for="hotspot in hotspotWithSmallForms"
                      :key="'h-' + hotspot['hotspotId']"
        />
        <form-element-lateral
                      :translate-labels="translateLabels"
                      :key="'f-' + formLateralID"
                      :form="formLateral"
        />
        <registration-hotspot />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { useTranslation } from "@/composables/useTranslation";
import FormElement from "@/playerVue3/components/form/form-element.vue";
import FormElementSmall from "@/playerVue3/components/form/form-element-small.vue";
import FormElementLateral from "@/playerVue3/components/form/form-element-lateral.vue";
import RegistrationHotspot from '@/playerVue3/components/hotspot/registration-hotspot'

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();
const { translate } = useTranslation();

// PROPS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const formLateralID = computed(() => {
    if (store.getFormData) {
        return store.getFormData.formId;
    }
    return 0;
});

const formLateral = computed(() => {
    if (store.getFormData) {
        return store.getFormData;
    }
    return {};
});

const hotspotWithLargeForms = computed(() => {
    return store.getFormsBySize('large');
});

const hotspotWithSmallForms = computed(() => {
    return store.getFormsBySize('small');
});

const translateLabels = computed(() => {
    return {
        textOther: translate('label.other'),
        textSelect: translate('label.select'),
        textMandatoryFields: translate('label.mandatory_fields'),
        textButtonSubmit: translate('label.submit'),
        textBack: translate('label.back'),
        textNext: translate('label.next'),
    };
});

// METHODS

// LYFECYCLE HOOKS
</script>
